import { Button, Typography } from '@mui/material';
import { FC } from 'react';
import GoogleLogin from 'react-google-login';

import { Colors, Google } from '@/assets';
import { APP_CONFIG } from '@/config';

interface IProps {
    title?: string;
}
export const LoginGoogleButton: FC<IProps> = ({ title = 'Sign in' }) => {
    // handle success login
    const onLoginSuccess = async (data: any) => {
        try {
            console.log(1);
        } catch (error) {
            //
        }
    };

    // login
    const onLoginWithGoogle = async (res: any) => {
        try {
            // const { accessToken } = res;
            // const response = await accountApi.postLoginWithGoogle(accessToken);
            // const { status, data } = response;
            // if (status === 200) {
            //     onLoginSuccess(data);
            // }
        } catch (error) {
            //
        }
    };

    return (
        <GoogleLogin
            clientId={APP_CONFIG.GOOGLE_CLIENT_ID}
            autoLoad={false}
            render={(renderProps) => (
                <Button
                    sx={{
                        border: '1px solid',
                        borderRadius: '8px',
                        py: 1.1,
                        borderColor: Colors.linkWater
                    }}
                    onClick={renderProps.onClick}
                >
                    <Google />
                    <Typography variant="h6" sx={{ ml: 1, fontWeight: 500 }}>
                        {title} with Google
                    </Typography>
                </Button>
            )}
            onSuccess={onLoginWithGoogle}
            onFailure={onLoginWithGoogle}
            cookiePolicy={'single_host_origin'}
        />
    );
};
